import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Building2, ListChecks, Sparkles, MoreHorizontal } from 'lucide-react';

const TABS = [
  { to: '/m/home',           label: 'Home',       icon: Home },
  { to: '/m/properties',     label: 'Properties', icon: Building2 },
  { to: '/m/tasks',          label: 'Tasks',      icon: ListChecks },
  { to: '/m/deal-analyzer',  label: 'Deal AI',    icon: Sparkles },
  { to: '/app/mobile-more',  label: 'More',       icon: MoreHorizontal },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const hideOn = ['/vendor-portal', '/login', '/', '/auth/callback', '/app/demo-tour'];
  if (hideOn.some(p => location.pathname === p || location.pathname.startsWith(p + '/'))) return null;

  return (
    <>
      {/* Safe-area spacer so page content isn't hidden behind the fixed bar */}
      <div className="h-24 md:hidden" aria-hidden="true"/>
      <nav
        className="md:hidden fixed bottom-0 inset-x-0 z-30 pb-[env(safe-area-inset-bottom)]"
        data-testid="mobile-bottom-nav"
      >
        <div className="mx-3 mb-3 rounded-3xl bg-white/95 backdrop-blur-xl shadow-2xl border border-white/70 h-16 grid grid-cols-5 items-center">
          {TABS.map((t) => <BottomTab key={t.to} tab={t}/>)}
        </div>
      </nav>
    </>
  );
}

function BottomTab({ tab }) {
  const Icon = tab.icon;
  return (
    <NavLink
      to={tab.to}
      data-testid={`mobile-tab-${tab.label.toLowerCase().replace(/[^a-z]+/g,'-')}`}
      className={({ isActive }) =>
        `flex flex-col items-center justify-center gap-0.5 text-[10px] transition-colors ${
          isActive ? 'text-[#679286]' : 'text-slate-500'
        }`
      }
    >
      {({ isActive }) => (
        <>
          <Icon size={20} strokeWidth={isActive ? 2.4 : 1.8}/>
          <span className={`${isActive ? 'font-semibold' : 'font-medium'}`}>{tab.label}</span>
        </>
      )}
    </NavLink>
  );
}
